export default function addGift(data) {
/*
id: "8710abea-af75-75ad-c2d0-5c3003a4bcca"
module: "acm_CampaignsAction"
name: "Akce Event #1"
prefix: "view"
type: null
*/
  this.popup("addGift", data);
}